import Vue from 'vue'
import VueI18n, { I18nOptions } from 'vue-i18n'
Vue.use(VueI18n)
const messages = {
  cn: {
    welcome: '欢迎到来，{name}',
    list: '第一：{0},第二：{1},第三：{2}'
  },
  us: {
    welcome: 'welcome，{name}',
    list: 'frist：{0},second：{1},third：{2}'
  }
}
// 格式化实现
// class CustomFormatter {
//     constructor(options: any) {
//     }
//     interpolate(message: any, values: any) {
//         debugger
//         return ['这是一个测试']
//     }
// }

const i18n = new VueI18n({
  locale: 'us',
  fallbackLocale: 'cn',
  // formatter: new CustomFormatter({}),
  messages
} as I18nOptions)

export default i18n
